import styled from 'styled-components'

export const AppWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
